import axios from 'axios';

export const api = axios.create({ baseURL: '/api', timeout: 15000 });
export const customerApi = axios.create({ baseURL: '/api', timeout: 15000 });

// Admin token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(res => res, err => {
  if (err.response?.status === 401) {
    localStorage.removeItem('admin_token');
    window.location.href = '/admin/login';
  }
  return Promise.reject(err);
});

// Customer token
customerApi.interceptors.request.use(config => {
  const token = localStorage.getItem('customer_token');
  if (token) config.headers['x-customer-token'] = `Bearer ${token}`;
  return config;
});

export default api;
